const allowedUnauthenticatedRoutes = Object.freeze([
    '/auth/login/',
    '/auth/logout',
    '/auth/forgot-password',
    '/auth/email-action',
    '/auth/saml/callback'
]);

export default allowedUnauthenticatedRoutes;
